// extracted by mini-css-extract-plugin
export var addButton = "_o7-0";
export var border = "_o7-8";
export var check = "_o7-h";
export var danger = "_o7-6";
export var dropdownContainer = "_o7-1";
export var editModalBody = "_o7-j";
export var footerContainer = "_o7-i";
export var fullWidth = "_o7-a";
export var hide = "_o7-9";
export var icon = "_o7-3";
export var input = "_o7-7";
export var inputFlex = "_o7-b";
export var inputWrapper = "_o7-c";
export var manualFocus = "_o7-5";
export var optionButton = "_o7-4";
export var pillWrapper = "_o7-e";
export var pointer = "_o7-2";
export var showOverflow = "_o7-f";
export var tagsFlex = "_o7-d";
export var xButton = "_o7-g";